import React from "react";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";

const EmailSentModal = ({ setstate1 }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="w-full">
      <div className="flex flex-col md:gap-8 gap-4">
        <a
          href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}`}
          className="cursor-pointer xl:w-36 w-30 h-12 relative flex-shrink-0 mx-auto"
        >
          <img
            src="https://gopdf.s3.eu-central-1.amazonaws.com/logos/Logo+go+pdf.svg"
            alt="Go PDF"
            fill={true}
            className="w-full h-full object-contain"
          />
        </a>
        <div>
          <h3 className="modal-heading mb-1">{t("Email has been sent!")}</h3>
          <p className="modal-description !text-base">
            {t("Check your inbox for 4 digit OTP we have sent you.")}
          </p>
        </div>
        <div className="flex flex-col gap-10">
          <div className="flex justify-center items-center">
            <svg
              width="181"
              height="167"
              viewBox="0 0 181 167"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.06">
                <ellipse
                  cx="25.8048"
                  cy="156.473"
                  rx="10.63"
                  ry="10.5273"
                  fill="#0A4F40"
                />
                <ellipse
                  cx="6.31498"
                  cy="137.874"
                  rx="5.31498"
                  ry="5.26363"
                  fill="#0A4F40"
                />
                <ellipse
                  cx="131.394"
                  cy="61.7278"
                  rx="49.6065"
                  ry="49.1272"
                  fill="#0A4F40"
                />
              </g>
              <g filter="url(#filter0_d_416_187)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.7197 65.9406C18.7197 61.9038 20.4236 58.0545 23.4119 55.3403L71.9463 11.2583C75.8314 7.72967 81.7805 7.7951 85.587 11.4083L131.897 55.3672C134.745 58.071 136.358 61.8259 136.358 65.7532V128.529C136.358 134.46 131.549 139.269 125.618 139.269H29.4597C23.5282 139.269 18.7197 134.46 18.7197 128.529V65.9406Z"
                  fill="#F5F5F5"
                />
              </g>
              <mask
                id="mask0_416_187"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="18"
                y="8"
                width="119"
                height="132"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.7197 65.9403C18.7197 61.9034 20.4236 58.0541 23.4119 55.34L71.9463 11.2579C75.8314 7.72927 81.7805 7.79471 85.5869 11.408L131.897 55.3668C134.745 58.0706 136.358 61.8255 136.358 65.7528V128.528C136.358 134.46 131.549 139.268 125.618 139.268H29.4597C23.5282 139.268 18.7197 134.46 18.7197 128.528V65.9403Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_416_187)">
                <g filter="url(#filter1_d_416_187)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7197 59.6025L73.3797 98.6093C75.8681 100.385 79.2095 100.385 81.6979 98.6093L136.358 59.6025V132.109C136.358 136.063 133.152 139.269 129.198 139.269H25.8797C21.9254 139.269 18.7197 136.063 18.7197 132.109V59.6025Z"
                    fill="white"
                  />
                </g>
                <g filter="url(#filter2_d_416_187)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M73.3797 100.262C75.8681 98.4859 79.2095 98.4859 81.698 100.262L136.358 139.268H18.7197L73.3797 100.262Z"
                    fill="white"
                  />
                </g>
              </g>
              <ellipse
                cx="63.696"
                cy="56.1738"
                rx="4.32493"
                ry="4.28315"
                fill="#B3B3B3"
              />
              <ellipse
                cx="93.9714"
                cy="56.1738"
                rx="4.32493"
                ry="4.28315"
                fill="#B3B3B3"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.29 70.1056C66.29 70.8993 66.8132 71.5946 67.5843 71.7829C69.7806 72.3193 74.4405 73.3076 78.9624 73.3076C83.4629 73.3076 87.9635 72.3287 90.0973 71.7906C90.86 71.5982 91.3747 70.9073 91.3747 70.1207C91.3747 68.9264 90.2177 68.0523 89.0538 68.3202C86.6884 68.8646 82.8197 69.5845 78.8992 69.5845C74.9488 69.5845 70.9983 68.8536 68.5989 68.3077C67.4389 68.0438 66.29 68.9159 66.29 70.1056Z"
                fill="#B3B3B3"
              />
              <defs>
                <filter
                  id="filter0_d_416_187"
                  x="0.81974"
                  y="0.0623035"
                  width="153.439"
                  height="166.414"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="9.30799" />
                  <feGaussianBlur stdDeviation="8.94999" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.0769928 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_416_187"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_416_187"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_416_187"
                  x="6.54774"
                  y="45.2825"
                  width="141.983"
                  height="104.011"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="-2.148" />
                  <feGaussianBlur stdDeviation="6.086" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_416_187"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_416_187"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter2_d_416_187"
                  x="13.7077"
                  y="91.7697"
                  width="127.663"
                  height="50.3629"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="-2.148" />
                  <feGaussianBlur stdDeviation="2.506" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.252325 0 0 0 0 0.423517 0 0 0 0 0.627631 0 0 0 0.02607 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_416_187"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_416_187"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <Button
            className="py-[1.125rem] rounded-[10px]"
            onClick={() => {
              setstate1(10);
            }}
          >
            {t("Continue")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailSentModal;
